import { Theme, createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    imagesWrapper: {
      display: 'flex',
      gap: `${theme.spacing.unit * 3}px`,
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      justifySelf: 'center',
    },
    container: {
      display: 'flex',
      borderRadius: `${theme.spacing.unit}px`,
      border: `1px solid ${theme.custom.palette.colorSupportPowder}`,
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
      flex: 1,
      flexDirection: 'column',
      rowGap: `${theme.spacing.unit * 5}px`,
    },
  });

export default styles;
